import * as yup from 'yup';

import { OutreachServiceSubmitFormDto } from './outreach-service-submit-form-dto';

export const OutreachFormValidationSchema: yup.SchemaOf<OutreachServiceSubmitFormDto> = yup.object().shape({
	key: yup.string().required('Enter API key')
});
